interface FixtureWithPickPath {
  id: string;
  pickPathId?: string | null;
}

/**
 * Builds a fixtureId → sequence-order map from already-filtered fixtures.
 *
 * Only fixtures with a non-empty pickPathId are included. If every pickPathId
 * is numeric, the number itself is used as the order; otherwise fixtures are
 * sorted with a numeric-aware locale compare and assigned 1-based ranks.
 *
 * Callers are responsible for any upstream filtering (e.g. by department)
 * before passing fixtures in.
 */
export function buildFixtureOrderingMap(fixtures: FixtureWithPickPath[]): Map<string, number> {
  const withPickPath = fixtures.filter((f) => f.id && f.pickPathId != null && f.pickPathId !== '');
  const allNumeric = withPickPath.every((f) => Number.isFinite(Number(f.pickPathId)));
  const sorted = [...withPickPath].sort((a, b) =>
    allNumeric
      ? Number(a.pickPathId) - Number(b.pickPathId)
      : (a.pickPathId as string).localeCompare(b.pickPathId as string, undefined, { numeric: true }),
  );
  const map = new Map<string, number>();
  sorted.forEach((f, idx) => map.set(f.id, allNumeric ? Number(f.pickPathId) : idx + 1));
  return map;
}
